import BaseError from "./base-error"

class CustomError extends BaseError {}

CustomError.apiMakerType = "CustomError"

export default CustomError
